import Vue from 'vue';
import Router from 'vue-router';
import auth from '@/api/auth';
import config from 'BRAND/config';
import authorityGuard from './AuthorityGuard';

const routerInstance = {
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-exact-active',
  routes: [
    {
      path: '/',
      alias: '*',
      name: 'Root'
    },
    ...config.routes
  ]
};

Vue.use(Router);
const router = new Router(routerInstance);

router.beforeEach(auth.samlGuard);
router.beforeEach(auth.loginGuard);
router.beforeEach(auth.rootGuard);
router.beforeEach(authorityGuard.authorityGuard);
router.afterEach((to, from) => {
  if (process.env.NODE_ENV === 'production') {
    // Dirty solution to get Vue context
    const ga = new Vue().$ga;
    if (ga) ga.page('/#' + to.fullPath);
  }
  const href = window.location.href;

  let comesFromGoogleOAuth = href.includes('access_token=');
  comesFromGoogleOAuth = comesFromGoogleOAuth && href.includes('&token_type=');
  comesFromGoogleOAuth = comesFromGoogleOAuth && href.includes('&expires_in=');
  comesFromGoogleOAuth = comesFromGoogleOAuth && href.includes('&scope=');
  if (comesFromGoogleOAuth) {
    const code = href.split('access_token=')[1].split('&token_type=')[0];
    // const scope = href.split("&scope=")[1];
    router.replace({name: 'integration', query: {code: code, state: '3'}});
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js